import { z } from 'zod';
import { BaseEntitySchema, CursorPageSchema, CursorQuerySchema, updatedAtField } from './common';
import { IdeaAuthorEmbedSchema } from './ideas';
import { PraiseUserEmbedSchema } from './praises';

export const CommentCreateInputSchema = z.object({
  body: z.string().trim().min(1).max(2000),
});
export type CommentCreateInput = z.infer<typeof CommentCreateInputSchema>;

export const IdeaCommentSchema = BaseEntitySchema.extend({
  updatedAt: updatedAtField,
  ideaId: z.string(),
  author: IdeaAuthorEmbedSchema.nullable(),
  body: z.string(),
  isPrivate: z.boolean(),
  isIdeaAuthor: z.boolean(),
  isMyComment: z.boolean(),
});
export type IdeaComment = z.infer<typeof IdeaCommentSchema>;

export const IdeaCommentListResponseSchema = CursorPageSchema.extend({
  comments: z.array(IdeaCommentSchema),
});
export type IdeaCommentListResponse = z.infer<typeof IdeaCommentListResponseSchema>;

export const IdeaCommentListQuerySchema = CursorQuerySchema;
export type IdeaCommentListQuery = z.infer<typeof IdeaCommentListQuerySchema>;

export const IdeaCommentCreateInputSchema = CommentCreateInputSchema;
export type IdeaCommentCreateInput = z.infer<typeof IdeaCommentCreateInputSchema>;

export const PraiseCommentSchema = BaseEntitySchema.extend({
  updatedAt: updatedAtField,
  praiseId: z.string(),
  author: PraiseUserEmbedSchema,
  body: z.string(),
  isPraiseAuthor: z.boolean(),
  isMyComment: z.boolean(),
});
export type PraiseComment = z.infer<typeof PraiseCommentSchema>;

export const PraiseCommentListResponseSchema = CursorPageSchema.extend({
  comments: z.array(PraiseCommentSchema),
});
export type PraiseCommentListResponse = z.infer<typeof PraiseCommentListResponseSchema>;

export const PraiseCommentListQuerySchema = CursorQuerySchema;
export type PraiseCommentListQuery = z.infer<typeof PraiseCommentListQuerySchema>;

export const PraiseCommentCreateInputSchema = CommentCreateInputSchema;
export type PraiseCommentCreateInput = z.infer<typeof PraiseCommentCreateInputSchema>;
